export default "__VITE_ASSET__DMAKrDiC__"